import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { withLoader } from '@/store/thunks/thunkWrappers';
import { isAPIError } from '@/utils/opaque/type-guards';
import { setSessionToken } from '@/utils/sessionStorage';

export const verifyOtpThunk = createAdminAsyncThunk<
  { registrationToken: string },
  { username: string; otp: string }
>('auth/verifyOtp', withLoader(
  async(params, { extra: { authService }, rejectWithValue }) => {
    try {
      const result = await authService.beginRegistration(params);
      setSessionToken(result.registrationToken);
      return result;
    } catch (error) {
      if (isAPIError(error) && error.fieldErrors !== null) {
        return rejectWithValue({ fieldErrors: error.fieldErrors });
      }
      throw error;
    }
  }
));
